//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Berekent de maandlast van een krediet op basis van de gegeven input.
     * @param input (optional) 
     * @return Success
     */
    maandlastKredietPost(input: MaandlastKredietInput | null | undefined): Promise<MaandlastKredietOutput> {
        let url_ = this.baseUrl + "/MaandlastKrediet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaandlastKredietPost(_response);
        });
    }

    protected processMaandlastKredietPost(response: Response): Promise<MaandlastKredietOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaandlastKredietOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaandlastKredietOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaandlastKredietOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaandlastKredietOutput>(null as any);
    }

    /**
     * Berekent het maximale krediet op basis van de gegeven input.
     * @param input (optional) De parameters voor de berekening
     * @return Success
     */
    maximaalKredietPost(input: MaximaalKredietInput | null | undefined): Promise<MaximaalKredietOutput> {
        let url_ = this.baseUrl + "/MaximaalKrediet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaximaalKredietPost(_response);
        });
    }

    protected processMaximaalKredietPost(response: Response): Promise<MaximaalKredietOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaalKredietOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaalKredietOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaalKredietOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaximaalKredietOutput>(null as any);
    }

    /**
     * Berekent de hoofdsom van een Private lease krediet op basis van de gegeven input.
     * @param input (optional) 
     * @return Success
     */
    privateLeasePost(input: PrivateLeaseInput | null | undefined): Promise<PrivateLeaseOutput> {
        let url_ = this.baseUrl + "/PrivateLease";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrivateLeasePost(_response);
        });
    }

    protected processPrivateLeasePost(response: Response): Promise<PrivateLeaseOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivateLeaseOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivateLeaseOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivateLeaseOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrivateLeaseOutput>(null as any);
    }

    /**
     * Geeft versie informatie van de applicatie.
     * @return De gevraagde versieinfo kon worden opgehaald en is beschikbaar in de uitvoer.
     */
    versionInfoGet(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVersionInfoGet(_response);
        });
    }

    protected processVersionInfoGet(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Er is iets foutgegaan tijdens het ophalen van de versieinfo. Kijken in de Messages van de uitvoer voor het probleem.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }
}

/** Bevat input voor de berekening van de krediet-maandlast. */
export interface MaandlastKredietInput {
    /** Bedrag kredietlimiet */
    hoofdsom: number | null;
    /** Bedrag huidige hoofdsom */
    restantHoofdsom: number | null;
    /** Percentage rente */
    rentePercentage: number | null;
    /** Percentage aflossing */
    aflossingPercentage: number | null;
    /** Aantal maanden looptijd */
    looptijdInMaanden: number | null;
    /** Slottermijn */
    slottermijn: number | null;
    /** Code veld. Soort krediet (Aflopend, Doorlopend, Studielening, Restschuldlening, ..) AflopendKrediet = 4, DoorlopendKrediet = 5, Studielening = 6, Restschuldlening = 7, PrivateLease = 13 */
    soortKrediet: MaandlastKredietInputSoortKrediet;
}

/** Bevat de output van de krediet-maandlast berekening. */
export interface MaandlastKredietOutput {
    /** Het resultaat van de berekening. */
    resultaat: MaandlastKredietResultaat | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de krediet-maandlast berekening. */
export interface MaandlastKredietResultaat {
    /** Bruto maandlast */
    brutoMaandlast: number | null;
    /** Theoretische looptijd in maanden */
    looptijdInMaanden: number | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

/** De berekening van het maximale krediet. */
export interface MaximaalKredietInput {
    /** De personen die bij de berekening betrokken zijn.
Als er 2 personen opgegeven worden, dan wordt uitgegaan van samenwonend. */
    personen: MaximaalKredietInputPersoon[] | null;
    /** De woonsituatie waarin de persoon/personen zich bevindt/bevinden. Eigendom = 0, Huur = 1, Inwonend = 2 */
    woonsituatie: MaximaalKredietInputWoonsituatie;
    /** De bruto hypotheeklast in de woonsituatie Eigendom. */
    brutoHypotheeklast: number | null;
    /** De huurlast in de woonsituatie Huur. */
    huurlast: number | null;
    /** Geeft aan of er sprake is van inwonende kinderen. */
    inwonendeKinderen: boolean | null;
}

/** Een persoon in de berekening van het maximaal krediet. */
export interface MaximaalKredietInputPersoon {
    /** Het netto inkomen per maand van de persoon. Indien weggelaten wordt uitgegaan van 0. */
    nettoInkomenPerMaand: number | null;
    /** Geeft aan of het dienstverband van de persoon vast is (true) of tijdelijk (false).
Indien weggelaten wordt uitgegaan van tijdelijk.
In geval van tijdelijk wordt het opgegeven inkomen voor 70% meegenomen. */
    vastDienstverband: boolean | null;
    /** De maandelijkse lasten als gevolg van kredieten van de persoon.
Indien weggelaten wordt uitgegaan van 0. */
    kredietlastPerMaand: number | null;
    /** Te maandelijks door de persoon te betalen alimentatie.
Indien weggelaten wordt uitgegaan van 0. */
    teBetalenAlimentatie: number | null;
    /** Geeft aan of de persoon een eigen auto heeft. */
    heeftEigenAuto: boolean | null;
    /** Maandelijks door de persoon te betalen kosten aan Private Lease.
Indien weggelaten wordt uitgegaan van 0. */
    kostenPrivateLease: number | null;
}

/** Het resultaat van de berekening maximaal krediet. */
export interface MaximaalKredietOutput {
    /** Het maximale krediet. */
    readonly maximaleLeencapaciteit: number | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat input voor de berekening van de Private lease hoofdsom. */
export interface PrivateLeaseInput {
    /** Aantal maanden looptijd */
    looptijdInMaanden: number | null;
    /** Bedrag maandlast */
    maandlast: number | null;
}

/** Bevat de output van de Private lease hoofdsom berekening. */
export interface PrivateLeaseOutput {
    /** Het resultaat van de berekening. */
    resultaat: PrivateLeaseResultaat | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de Private lease hoofdsom berekening. */
export interface PrivateLeaseResultaat {
    /** Hoofdsom */
    hoofdsom: number | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export interface BadRequestResult {
    readonly statusCode: number | null;
}

export enum MaandlastKredietInputSoortKrediet {
    AflopendKrediet = "AflopendKrediet",
    DoorlopendKrediet = "DoorlopendKrediet",
    Studielening = "Studielening",
    Restschuldlening = "Restschuldlening",
    PrivateLease = "PrivateLease",
}

export enum MaximaalKredietInputWoonsituatie {
    Eigendom = "Eigendom",
    Huur = "Huur",
    Inwonend = "Inwonend",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}